import React, {FC} from 'react';

import {AccountsJobModel} from '../../../../models/api/jobModel';
import {
  AccountsCsvImportBannerState,
  AccountsCsvImportErrorBannerState,
} from '../../../../store/panels/app/banners/bannersState';
import {AppPanelId} from '../../../../store/panels/panelStateBase';
import {AccountsCSVImportBannerContainer} from './accountsCSVImportBannerContainer';

/*
 * Props.
 */

interface AccountsCsvImportBannersProps {
  jobBanners: ReadonlyArray<AccountsCsvImportBannerState>;
  errorBanners: ReadonlyArray<AccountsCsvImportErrorBannerState>;
  accountImportJobs: ReadonlyArray<AccountsJobModel>;
  panelId: AppPanelId;
}

/*
 * Component.
 */

export const AccountsCSVImportBanners: FC<AccountsCsvImportBannersProps> = ({
  accountImportJobs,
  errorBanners,
  jobBanners,
  panelId,
}) => (
  <>
    {jobBanners.map((banner) => {
      const job = accountImportJobs.find((importJob) => importJob.id === banner.jobId);
      return (
        <AccountsCSVImportBannerContainer
          key={banner.uid}
          bannerUid={banner.uid}
          panelId={panelId}
          job={job}
        />
      );
    })}
    {errorBanners.map((banner) => (
      <AccountsCSVImportBannerContainer
        key={banner.uid}
        bannerUid={banner.uid}
        panelId={panelId}
        isErrorBanner
      />
    ))}
  </>
);
